import {
  useCallback 
} from "react"

export const useTrackOrder = (props) => {
  const {
    afterSubmit 
  } = props

  const handleSubmit = useCallback(
    async (formState) => {
      const {
        email, ordernumber 
      } = formState.values

      if (afterSubmit) {
        afterSubmit(email, ordernumber)
      }
    },
    [afterSubmit]
  )

  return {
    handleSubmit,
  }
}
